import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AuthService, UserService } from 'src/app/core/services';
import { iranPhoneValidator } from 'src/app/shared';
import { UserSchema } from 'src/app/core/models';
import { IsLoadingService } from '@service-work/is-loading';

@Component({
  selector: 'activation-get-phone',
  templateUrl: './get-phone.component.html',
  styleUrls: ['./get-phone.component.scss'],
})
export class GetPhoneComponent implements OnInit {
  @Input('userData') userData!: UserSchema;
  @Output('phone-update') phoneUpdate: EventEmitter<boolean>;
  @Output('changeState') stateChange: EventEmitter<
    'updatePhone' | 'confirmCode'
  >;

  public checkPhoneLoading$ = this.loadingService.isLoading$({
    key: 'checkPhoneExistence',
  });

  public phoneUpdateLoading$ = this.loadingService.isLoading$({
    key: 'updatePhone',
  });

  private _subscriptions: Subscription[] = [];
  public set subscriptions(subscription: Subscription | undefined) {
    if (subscription) {
      this._subscriptions.push(subscription);
    }
  }

  constructor(
    private authService: AuthService,
    private userService: UserService,
    public loadingService: IsLoadingService,
    private formBuilder: FormBuilder
  ) {
    this.stateChange = new EventEmitter();
    this.phoneUpdate = new EventEmitter();

    this.phoneUpdateForm = this.formBuilder.group({
      phone: [
        '',
        [
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required,
          iranPhoneValidator,
        ],
      ],
    });
  }

  ngOnInit(): void {
    this.subscriptions = this.phone.valueChanges
      .pipe(filter(() => this.phone.valid))
      .subscribe(this.checkPhoneExistence());
  }

  public phoneNumberAcceptable: boolean = false;
  public _checkingPhoneNumber: boolean = false;
  phoneUpdateForm!: FormGroup;
  // phoneUpdateForm = new FormGroup({
  //   phone: new FormControl('', [
  //     Validators.minLength(11),
  //     Validators.maxLength(11),
  //     Validators.required,
  //     iranPhoneValidator,
  //   ]),
  // });

  public get phone() {
    return this.phoneUpdateForm.get('phone') as AbstractControl;
  }

  checkPhoneExistence() {
    const parent = this;

    return (phoneNo: string) => {
      parent._checkingPhoneNumber = true;
      parent.loadingService.add({ key: 'checkPhoneExistence' });

      parent.subscriptions = parent.authService
        .checkPhoneExistence(phoneNo)
        .subscribe((result: any) => {
          if (!result) {
            parent.phone.setErrors({ phoneExists: { valid: false } });
          }

          parent._checkingPhoneNumber = false;
          parent.phoneNumberAcceptable = true;
          parent.loadingService.remove({ key: 'checkPhoneExistence' });
        });
    };
  }

  /**
   * Update user phone.
   */
  updateUserPhone() {
    this.loadingService.add({ key: 'updatePhone' });
    this.subscriptions = this.userService
      .updateUserPhone(this.phone.value)
      .subscribe(
        (data) => {
          this.stateChange.emit('confirmCode');
          this.loadingService.remove({ key: 'updatePhone' });
        },
        (error) => {
          console.error(error);
          this.loadingService.remove({ key: 'updatePhone' });
        }
      );
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
